import React, { useCallback, useMemo } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { guid } from '@bydesign-ui/utils';
import { Down, Up } from '../../../common/icons';
import { useCascader } from '../../../hooks/cascader';
import { RcPopover } from '../../../units/popover-wrapper';
import { SelectInput } from '../../select/components/SelectInput';
import { useCascaderSelectPopper } from '../hooks/useCascaderSelectPopover';
export function CascaderSelectPopper(props) {
  var _a, _b;

  var invalid = props.invalid,
      renderItem = props.renderItem,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      autoAlign = props.autoAlign,
      maxPopoverWidth = props.maxPopoverWidth,
      placeholder = props.placeholder,
      popoverStyle = props.popoverStyle,
      onShow = props.onShow,
      onHide = props.onHide,
      onVisibleChange = props.onVisibleChange,
      show = props.show,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? false : _props$clearable,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      renderSelectedName = props.renderSelectedName,
      _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      searchPlaceholder = props.searchPlaceholder,
      searchDebounceTime = props.searchDebounceTime,
      renderSearchItem = props.renderSearchItem,
      onSearchChange = props.onSearchChange,
      autoFocusSearch = props.autoFocusSearch,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      filled = props.filled;
  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var handleShow = useRefCallback(onShow);
  var handleHide = useRefCallback(onHide);
  var cascader = useCascader();

  var _useCascaderSelectPop = useCascaderSelectPopper({
    show: show,
    autoAlign: autoAlign,
    maxPopoverWidth: maxPopoverWidth,
    renderItem: renderItem,
    triggerId: triggerId,
    searchable: searchable,
    searchPlaceholder: searchPlaceholder,
    searchDebounceTime: searchDebounceTime,
    renderSearchItem: renderSearchItem,
    onSearchChange: onSearchChange,
    autoFocusSearch: autoFocusSearch,
    emptyRender: emptyRender,
    emptyContent: emptyContent
  }),
      getSelectPopover = _useCascaderSelectPop.getPopover,
      displayInfo = _useCascaderSelectPop.displayInfo;

  var handleClear = useCallback(function (val) {
    if (!val) {
      cascader.resetValue();
    }
  }, []);
  var selectedValue = displayInfo.length ? renderSelectedName ? renderSelectedName(displayInfo[0]) : ((_b = (_a = displayInfo[0]).getAncestorSearchValue) === null || _b === void 0 ? void 0 : _b.call(_a)) || '' : '';
  return React.createElement(React.Fragment, null, React.createElement(SelectInput, {
    invalid: invalid,
    clearable: clearable,
    suffix: show ? React.createElement(Up, null) : React.createElement(Down, null),
    value: selectedValue,
    placeholder: placeholder,
    size: size,
    disabled: disabled,
    onValueChange: handleClear,
    triggerId: triggerId,
    readOnly: cascader.treeMapData.readonly,
    htmlReadOnly: true,
    filled: filled
  }), React.createElement(RcPopover, {
    show: show,
    getPopper: getSelectPopover,
    offset: {
      x: 0,
      y: 4
    },
    arrow: false,
    placement: placement,
    triggerIds: triggerIds,
    onShow: handleShow,
    style: popoverStyle,
    onHide: handleHide,
    onVisibleChange: onVisibleChange,
    scaleAnimation: "y"
  }));
}